import * as _ from 'lodash';

import {
  getCurrentUsername,
  getInitialFlagValue,
  getReportOwnerUsername,
  getReportRunEntryPath,
} from '@mode/shared/util-js';
import { ReportFilterFacade, ReportViewerFacade } from '@mode/report-viewer/domain';
import { ChartExportFacade } from '@mode/file-exports/domain';
import { combineLatest, map } from 'rxjs';
import { FeatureFlag } from '@mode/shared/contract-common';

const isExportDatasetsEnabled = getInitialFlagValue(FeatureFlag.NotebookExportDatasets);
export function EmbedControllerFn(
  $window: angular.IWindowService,
  $scope,
  $q,
  ReportRunModel,
  AccountModel,
  $timeout,
  ModeCollection,
  ReportStateService,
  filterFacade: ReportFilterFacade,
  DatasetService,
  ReportRunDataService,
  ClientDataService,
  NotebookDataService,
  reportViewerFacade: ReportViewerFacade,
  chartExportFacade: ChartExportFacade
) {
  const deferredDataset = $q.defer();

  $scope.dataset = deferredDataset.promise;

  // rejected promises without any subscribers will throw an exception
  $scope.dataset.catch(function () {});

  $scope.reportOwnerId = getReportOwnerUsername($window.document);
  $scope.filterPanelIsOpen = false;

  const currentUsername = getCurrentUsername($window.document);

  const reportRunEntryPath = getReportRunEntryPath($window.document);

  const reportToken = reportRunEntryPath.match(/reports\/(\w+)\//)[1];

  const reportRunSegment = /runs\/(\w+)\/*/;

  const reportRunToken = reportRunSegment.test(reportRunEntryPath)
    ? reportRunEntryPath.match(reportRunSegment)[1]
    : null;

  ClientDataService.setLoggedInState(currentUsername != null);
  $scope.showDownloadsLink$ = combineLatest([chartExportFacade.drawerIsOpen$, chartExportFacade.hasNoExports$]).pipe(
    map(([isOpen, noExports]) => !isOpen && !noExports)
  );

  AccountModel.find({
    username: $scope.reportOwnerId,
    useEntryPath: true,
    includes: ['organization_features'],
  }).then(function (owner) {
    ClientDataService.loadReportOwner(owner._resource);
  });

  if (currentUsername != null) {
    AccountModel.find({
      username: currentUsername,
      useEntryPath: true,
    }).then(function (account) {
      ClientDataService.loadAccount(account._resource);
    });
  }

  $scope.toggleFilterPanel = function toggleFilterPanel($state) {
    setFilterPanelDisplayState($state);
  };
  $scope.showDownloads = () => {
    chartExportFacade.updateDrawerState(true);
  };
  $scope.handleFilterPanelDisplayChange = function ($isOpen) {
    setFilterPanelDisplayState($isOpen);
  };
  function setFilterPanelDisplayState(isOpen) {
    $timeout(function () {
      $scope.filterPanelIsOpen = isOpen;
    });
  }

  $scope.error = {
    show: false,
    message: '',
  };

  $scope.alert = {
    not_found: false,
  };
  $scope.DS = DatasetService;

  ReportRunDataService.reportRunState$.subscribe(function (state) {
    const newExecutingState = state.reportRun && state.reportRun.loading;

    // Might not be needed anymore
    if (!$scope.executing && newExecutingState) {
      deferredDataset.resolve($scope.DS.datasets);
    }

    $scope.executing = newExecutingState;
  });

  function initializeFilters(reportRun) {
    reportRun.report().then(function (report) {
      filterFacade.loadReportFilters(report.token);
      report
        .reportFilters()
        .then(ModeCollection.elements)
        .catch(() => [])
        .then(function (filters) {
          filterFacade.loadReportFilterResources(
            _.map(filters, function (filterResource: any) {
              return filterResource._resource;
            })
          );
        });
    });
    return reportRun;
  }

  reportViewerFacade.selectReport($scope.reportOwnerId, reportToken, reportRunToken);

  ReportRunModel.find({
    token: 'noop',
    useEntryPath: true,
    includes: [
      {
        python_cell_runs: {
          python_cell_runs: 'python_cell_run_results',
        },
      },
      {
        report: [
          'report_filters',
          'report_theme',
          {
            queries: {
              queries: [
                {
                  charts: {
                    charts: 'color_palette',
                  },
                },
                'query_tables',
              ],
            },
          },
          ...(isExportDatasetsEnabled
            ? [
                {
                  local_datasets: {
                    local_datasets: [
                      'new_chart',
                      {
                        charts: {
                          charts: ['color_palette'],
                        },
                      },
                      'new_query_table',
                      'query_tables',
                    ],
                  },
                },
              ]
            : []),
          {
            python_visualizations: {
              python_visualizations: [
                'python_cell',
                {
                  python_cell_run: 'python_cell_run_results',
                },
              ],
            },
          },
        ],
      },
    ],
  })
    .then(initializeFilters)
    .then(function (reportRun) {
      ClientDataService.loadReportRunSuccess(reportRun._resource);
      NotebookDataService.pollPython();
      ReportStateService.setReportRun(reportRun);
      ReportRunDataService.pollLoadedReportRun(reportRun);
    })
    .catch(function (error) {
      if (error && error.status) {
        $scope.alert.not_found = 'true';
      }
    });
}

EmbedControllerFn.$inject = [
  '$window',
  '$scope',
  '$q',
  'ReportRunModel',
  'AccountModel',
  '$timeout',
  'ModeCollection',
  'ReportStateService',
  'ReportFilterFacade',
  'DatasetService',
  'ReportRunDataService',
  'ClientDataService',
  'NotebookDataService',
  'ReportViewerFacade',
  'ChartExportFacade',
];
